<template>
  <div class="article-keyword-tag py-2">
    <div
      v-for="(keyword, index) in article.keywords"
      :key="index"
      class="article-keyword-tag__tag-container rounded d-inline-block px-4 py-2 mx-2 mb-2 background-inverted foreground-primary text-center"
    >
      <nuxt-link
        data-test-id="KeywordsLink"
        :to="`/engage/${partner}/search-dashboard?keywords=${keyword}`"
        class="text-decoration-none"
        >{{ keyword }}</nuxt-link
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "ArticleKeywordTag",
  props: {
    article: { type: Object, required: true },
  },
  computed: {
    partner() {
      return this.$config.partner;
    },
  },
};
</script>

<style lang="scss" scoped>
.article-keyword-tag {
  &__tag-container {
    font-size: 14px;
    background-color: #f0f0f0;
  }
}
</style>
